import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=aebf73f6&"
import script from "./Feedback.vue?vue&type=script&lang=ts&"
export * from "./Feedback.vue?vue&type=script&lang=ts&"
import style0 from "./Feedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports